import React from 'react';

const AssumptionsLimitations = () => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h2 className="text-2xl font-bold text-slate-800 dark:text-white">
        ⚠️ Assumptions & Limitations
      </h2>
      <span className="bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1 rounded-full text-sm font-medium">
        Premium Feature
      </span>
    </div>

    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-amber-800 dark:text-amber-300 mb-4">
        Key Assumptions
      </h3>
      <ul className="space-y-2 text-sm text-amber-700 dark:text-amber-400">
        <li>• Energy prices remain stable at current rates</li>
        <li>• Operating hours and production levels consistent</li>
        <li>• Equipment performance within normal parameters</li>
        <li>• Implementation follows recommended specifications</li>
      </ul>
    </div>

    <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-red-800 dark:text-red-300 mb-4">
        Limitations
      </h3>
      <ul className="space-y-2 text-sm text-red-700 dark:text-red-400">
        <li>• Estimates based on industry benchmarks, not site-specific data</li>
        <li>• Actual savings may vary ±20% depending on implementation quality</li>
        <li>• Does not account for future equipment changes or expansions</li>
        <li>• Professional assessment recommended for final validation</li>
      </ul>
    </div>
  </div>
);

export default AssumptionsLimitations;


